import gql from 'graphql-tag'

export const STAFF_LOGIN = gql`
  mutation STAFF_LOGIN($email: String!, $password: String!) {
    staffLogin(email: $email, password: $password) {
      token
    }
  }
`
